import { H1, H2, Text } from '../ui/typography';
import PageSeo from '../seo/PageSeo';

function Psychology() {
  return (
    <>
      <PageSeo
        title="Psihološko svetovanje Ljubljana"
        description="Psihološko svetovanje v Ljubljani pri Špeli Verbnik."
        path="/psychology"
      />
      <div className='bg-primaryBg pl-4 pr-4'>
        <div className="lg:w-1/2 m-auto flex flex-col items-center align-middle pt-12 pb-12">
          <H1 style={{color: "#616287"}}>Psihološko svetovanje</H1>
          <H2 className="text-center">sočutna podpora, lažji koraki</H2>
          <div className='flex justify-center align-middle pt-12 w-full'>
            <img className='w-1/3 md:w-[13%]' src="/assets/logo_filler_sage.svg" alt="" />
          </div>
          <Text className="text-base pt-12">Na življenjskih križiščih, ko preverjene poti ne vodijo več naprej, je za oblikovanje nove smeri včasih potreben varen in zaupen prostor za razmislek. Psihološko svetovanje ponuja prav to: je strukturiran proces, osredotočen na obravnavo konkretnih, trenutnih tem, kot so izboljšanje odnosov, sprejemanje življenjskih odločitev, soočanje s stresom ali drugimi raznolikimi stiskami. </Text>
          
          <H2 className="pt-12 text-3xl">Kako poteka proces psihološkega svetovanja?</H2>
          <Text className="text-base pt-6">Psihološko svetovanje je sodelovalen in v rešitve usmerjen proces. Osredotočen je na trenutno situacijo in opredelitev jasnih ciljev. Skozi pogovor klient razvija nove poglede na svoje izzive in težave, prepozna lastne vire moči in oblikuje konkretne, uresničljive korake, ki na njegovi poti puščajo bolj avtentične stopinje.</Text>
          <Text className="text-base pt-6">Cilj je, da klient lažje in bolj samozavestno stopa skozi izzive na svoji življenjski poti.</Text>
          <Text className="text-base pt-6">Pristop je celosten, saj upošteva, da so trenutni izzivi vedno prepleteni s klientovimi pomembnimi odnosi in širšim življenjskim kontekstom. Tako so rešitve, ki jih klient oblikuje, resnično njegove in dolgoročno smiselne.</Text>

          <Text className="text-base pt-6">Psihološko svetovanje izvajam tudi v okviru programa EAP, pod okriljem Inštituta za razvoj inovacij Ljubljana. Program omogoča strokovno psihološko podporo zaposlenim pri soočanju z delovnimi in osebnimi izzivi. </Text>

          <Text className="text-base pt-6">* Za razliko od psihoterapije, ki se pogosto osredotoča na globlje, dolgotrajnejše vzorce, je svetovanje usmerjeno v reševanje specifičnih, aktualnih težav v krajšem časovnem okviru. Če niste prepričani, katera oblika podpore bi bila najprimernejša za vas, lahko o tem spregovoriva na uvodnem srečanju.</Text>

        </div>
      </div>
    </>
    
  );
}

export default Psychology; 